import { NgModule } from '@angular/core'; import { MatListModule, MatSidenavModule, MatIconModule, MatToolbarModule, MatButtonModule } from '@angular/material';
@NgModule({ imports: [MatSidenavModule], exports: [MatIconModule, MatToolbarModule, MatListModule, MatSidenavModule, MatButtonModule] })
export class MaterialModule { }
